module.exports = __webpack_public_path__ + "img/D201703_2.6c4faf9f.jpg";